const { REACT_APP_BUILD_ENV } = process.env;

const submitAppHosted = (window.APP_ENV && window.APP_ENV.urls) ? window.APP_ENV.urls.submitApp : null;

const submitAppDomains = {
    dev: 'localhost:3000',
    manager: submitAppHosted,
    submit: window.location.origin
};

export const submitAppDomain = submitAppDomains[REACT_APP_BUILD_ENV];
